import React from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import useFetch from "../fetch";
import { sendStaffAppMetaData } from "../staffApp/eventTriggers";

function CounselingHistoryFormModel() {
  const props = useSelector((state) => {
    return {
      show: state.ui.counselingHistoryModal.show,
      counselingHistory: state.ui.counselingHistoryModal.counselingHistory,
      action: state.ui.counselingHistoryModal.action,
      organizationName: state.organization.name,
      resident: state.resident,
      isStaffApp: state.config.isStaffApp,
      counselingHistoryTabDefaultMetaData: state.config.tab_default_meta_data.find(
        (tab) => tab.detail == "counseling_history"
      ),
      hasDelete: state.current_user.permissions.includes("Delete"),
      hasEdit: state.current_user.permissions.includes("Edit"),
    };
  });

  const dispatch = useDispatch();
  const fetch = useFetch();
  const closeModal = () =>
    dispatch({
      type: "CLOSE_RESOURCE_MODAL",
      payload: { resourceName: "counselingHistory" },
    });
  const updateField = (name, value) =>
    dispatch({
      type: "UPDATE_RESOURCE_FIELD",
      payload: { resourceName: "counselingHistory", name, value },
    });
  const deleteCounselingHistory = (counselingHistory) =>
    dispatch({ type: "DELETE_COUNSELING_HISTORY", payload: { counselingHistory } });
  const setDefaultStaffAppMetaData = () =>
    sendStaffAppMetaData(props.counselingHistoryTabDefaultMetaData);

  const updateResidentCounselingHistoriesAction = () => {
    return (dispatch, getState) => {
      const state = getState();
      var counselingHistories = { ...state.ui.counselingHistoryModal.counselingHistory, organization_id: state.organization.id }
      return fetch(
        `/organizations/${state.organization.name}/residents/${state.resident.id}.json`,
        {
          method: "PATCH",
          headers: {'Content-Type': 'application/json'},
          data: JSON.stringify({
            resident: {
              counseling_histories_attributes: [counselingHistories]
            },
          })
        }
      ).then((data) => {
        dispatch({
          type: "UPDATE_COUNSELING_HISTORY",
          payload: { counselingHistory: data.counseling_histories },
        });
      });
    };
  };

  const updateResidentCounselingHistories = (counselingHistory) => {
    const { organizationName, resident } = props;
    var counselingHistories = { ...counselingHistory, organization_id: props.resident.organization_id }
    return fetch(
      `/organizations/${organizationName}/residents/${resident.id}.json`,
      {
        method: "PATCH",
        headers: {'Content-Type': 'application/json'},
        data: JSON.stringify({
          resident: {
            counseling_histories_attributes: [counselingHistories]
          },
        })
      }
    );
  };

  const removeCounselingHistory = () => {
    updateResidentCounselingHistories({
      id: props.counselingHistory.id,
      _destroy: true,
    }).then(() => {
      deleteCounselingHistory(props.counselingHistory);
      if (props.isStaffApp) alert("Counseling History successfully deleted.");
      setDefaultStaffAppMetaData();
      closeModal();
    });
  };

  const saveCounselingHistory = () => {
    dispatch(updateResidentCounselingHistoriesAction()).then((data) => {
      if (props.isStaffApp) alert("Counseling History changes saved.");
      setDefaultStaffAppMetaData();
      closeModal();
    });
  };

  const { title, description } = props.counselingHistory;

  React.useEffect(() => {
    let saveCounselingHistoryFunction = (e) => {
      saveCounselingHistory();
    };
    document.addEventListener("saveCounselingHistory", saveCounselingHistoryFunction);
    return () =>
      document.removeEventListener(
        "saveCounselingHistory",
        saveCounselingHistoryFunction
      );
  }, []);

  return (
    <Modal
      animation={!props.isStaffApp}
      show={props.show}
      onHide={() => closeModal()}
    >
      {!props.isStaffApp && (
        <Modal.Header closeButton>
          <Modal.Title>Counseling History</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body className={props.hasEdit ? "p-4" : "p-4 form-modal-width"}>
        {props.hasEdit ? (
          <>
            <Form.Group controlId="counselingHistoryName">
              <Form.Label>Title</Form.Label>
              <Form.Control
                value={title}
                onChange={(e) => {
                  updateField("title", e.target.value);
                }}
              />
            </Form.Group>
            <Form.Group controlId="counselingHistoryDescription">
              <Form.Label>Description</Form.Label>
              <Form.Control
                value={description}
                onChange={(e) => {
                  updateField("description", e.target.value);
                }}
              />
            </Form.Group>
          </>
        ) : (
          <>
            <Form.Group>
              <Form.Label>Title</Form.Label>
              <div className="form-control-plaintext">{title || 'N/A'}</div>
            </Form.Group>
            <Form.Group>
              <Form.Label>Description</Form.Label>
              <div className="form-control-plaintext">{description || 'N/A'}</div>
            </Form.Group>
          </>
        )}
      </Modal.Body>
      {!props.isStaffApp ? (
        <Modal.Footer>
          {props.action === "edit" && props.hasDelete && (
            <Button
              variant="outline-danger"
              onClick={() => removeCounselingHistory(props.counselingHistory)}
            >
              Delete
            </Button>
          )}
          <Button variant="info" onClick={() => saveCounselingHistory()}>
            {props.action === "edit" ? "Update" : "Create"}
          </Button>
        </Modal.Footer>
      ) : (
        <div className="p-4">
          {props.action == "edit" && props.hasDelete &&  (
            <Button
              onClick={() => removeCounselingHistory(props.counselingHistory)}
              variant="outline-danger"
              className="w-100"
            >
              Delete
            </Button>
          )}
        </div>
      )}
    </Modal>
  );
}

export default CounselingHistoryFormModel;
